// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox'
import Avatar               from 'material-ui/Avatar';
var Spinner = require('react-spinkit');
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';




class CustomerDetails extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      dialog_open: false,
      active_tab: (props.match.params.page == 'booking') ? 2 : 1,
      pause_date:'',
      subscription_id:''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    console.log(props);
    console.log(props.match.params.page);
    
  }

  handleTabClick(tabIndex){
        this.setState({
            active_tab: tabIndex,
        });
    }

  handleOpen = (id) => {
    this.setState({dialog_open: true});
    this.setState({subscription_id:id})
  };

  handleClose = () => {
    this.setState({dialog_open: false});
  };


  componentDidMount() {
    this.customerFulldetails();
   
  }
   customerFulldetails(){
    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data}))
       .catch(error => error);
  }
  switchProfile(id, props){
    this.setState({dialog_open: false});
    console.log(props);
    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data,  id: id}))
       .catch(error => error);
  }

  handleChange(event) {
    this.setState({
      pause_date: event.target.value
    })
    
  }

  handleSubmit(event) {
    event.preventDefault();
    if(this.state.pause_date){
    this.postPauseSubscription(this.state.pause_date, this.state.subscription_id, this.props);
    }
    else{
      alert("Please Enter Date")
    }
  }

  missedCallsms(props) {
    const url = `${getLocationOrigin()}/lead/lead_missed_call_sms/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
      });
  }

  postPauseSubscription(pause_date, subscription_id, props){
    this.setState({dialog_open: false});
    var date = moment(pause_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    const url = `${getLocationOrigin()}/subscriptionpause/pause_subscription/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'pause_date': date,
                         'subscription_id':subscription_id,
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(function(response){
        alert(response.Message);
        window.location.reload();
       })
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  venueSms(props) {
    const url = `${getLocationOrigin()}/lead/send_venue_sms/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
      });
  }
  renderTabButtons(active_tab) {
      return(
                <div style={{justifyContent: 'center', padding: '1%', display: 'flex', }} className="col-md-12">
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==1)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==1) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==1)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==1?'active':''}`} onClick={()=>this.handleTabClick(1)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Leads</span>  
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==2)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==2) ? '' :'0 6px 4px -4px #000', width: '33%', color: (active_tab==2)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==2?'active':''}`} onClick={()=>this.handleTabClick(2)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}> Bookings</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==3)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==3) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==3)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==3?'active':''}`} onClick={()=>this.handleTabClick(3)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Subscriptions</span>
                  </div>                                                                       
                </div>
      )
    }


  render() {
    var custid = this.state.id;
    console.log('render');
    console.log(custid);
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleSubmit}
      />,
    ];
    if(this.state.profile_data){
      console.log(this.state.profile_data);
      console.log(this.state.profile_data[custid]);
    }
    return(
      <div style={styles.container}>
      { this.state.profile_data ? 
        <div className="row col-md-12 table-bordered" style={styles.table}>
            <div className="col-md-12" style={{flexDirection: 'row', justifyContent: 'space-between', border: '1px solid #eee',}}>
                  <h4 style={{textAlign:'center'}}>Other Profiles</h4>
                  {
                    this.state.profile_list.map((list, index)=>(
                      <div key={index} style={{display: (list.selected == true) ? 'none': 'flex' , alignSelf: 'center', marginBottom: '4px', flexDirection: 'column', float: 'right'}} className="col-md-2" onClick={()=>{this.switchProfile(list.id, this.props)}}>
          
                        <Avatar size={60} src={list.photo.includes('http') ? list.photo : 'https://api.sporthood.in'+list.photo} style={{alignSelf: 'center'}}/>
                         <span style={{fontSize: '100%', fontWeight: 600, paddingTop: '1%', alignSelf: 'center', }} onClick={()=>{this.switchProfile(list.id, this.props)}}>{list.name}</span>

                      </div>))
                  }
               <div style={{flexDirection: 'column', }}>   
                <button className="btn" style={{border: 'none', backgroundColor: '#fff', float: 'left', margin: '13px'}}>
                <Link to={`../../crud/childProfile/${this.state.id}`}> <i className="fa fa-plus-circle" style={{fontSize: 'large'}}></i>
                </Link>
                <span style={{fontSize: '100%', fontWeight: 600, margin: '4px'}}>Add profile</span>
                </button>
               </div>                           
            </div>  
            <div style={{flexDirection: 'row', display: 'flex',  border: '1px solid #eee',}} className="col-md-12">
              <div className="col-md-2" style={{flexDirection: 'column', display: 'flex', justifyContent: 'space-between', marginTop: '3px'}}>
              <div style={{flexDirection: 'row'}}>
              <Avatar size={90} src={this.state.profile_data[this.state.id].photo.includes('http')? this.state.profile_data[this.state.id].photo : 'https://api.sporthood.in'+this.state.profile_data[this.state.id].photo} />
             
              </div>
              <span style={{fontSize: '120%', fontWeight: 600, paddingTop: '1%', marginLeft: '12px', color: '#FC427B'}}>{this.state.profile_data[this.state.id].name}</span>
              <span style={{fontSize: '100%', fontWeight: 600, paddingTop: '1%', marginLeft: '10px', color: '#FC427B'}}>{this.state.profile_data[this.state.id].mobile_no}</span>
              <div className="col-md-1">
                            <Link
                              to={`/crud/editProfile/${this.state.id}`}
                              className="btn btn-info btn-md pull-left"
                              style={{
                                  backgroundColor: '#FDD60B',
                                  color: '#000',
                                  marginBottom: '2px'
                              }}>
                              <span style={{color: '#000'}}></span>
                              Edit Profile
                          </Link>
                          </div>
              </div>

              <div className="col-md-3" style={{flexDirection: 'column', display: 'flex', marginTop: '3px'}}>
              <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '10px',marginLeft: '10px', color: (this.state.profile_data[this.state.id].customer_type) ?'#000' : '#FF0000', whiteSpace: 'nowrap',}}>Type: {this.state.profile_data[this.state.id].customer_type ? this.state.profile_data[this.state.id].customer_type : "No data"}</span>
              <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '10px',marginLeft: '10px', color: (this.state.profile_data[this.state.id].email)? '#000': '#FF0000', whiteSpace: 'nowrap',}}>Email: {this.state.profile_data[this.state.id].email ? this.state.profile_data[this.state.id].email : "No data"}</span>
              <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '10px',marginLeft: '10px', color: (this.state.profile_data[this.state.id].date_of_birth)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>DOB: {this.state.profile_data[this.state.id].date_of_birth ? this.state.profile_data[this.state.id].date_of_birth : "No data"}</span>
              <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '10px',marginLeft: '10px', color:(this.state.profile_data[this.state.id].gender)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Gender: {this.state.profile_data[this.state.id].gender ? this.state.profile_data[this.state.id].gender : "No data"}</span>
             {
              this.state.profile_data[this.state.id].customer_type == 'Child' ?
              <div style={{flexDirection: 'column', display: 'flex', justifyContent: 'space-between',}}>
                <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '10px',marginLeft: '10px', color: (this.state.profile_data[this.state.id].jersey_size)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>Size: {this.state.profile_data[this.state.id].jersey_size ? this.state.profile_data[this.state.id].jersey_size : "Nil"}</span>
                <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '10px',marginLeft: '10px', marginTop: '3px',color: (this.state.profile_data[this.state.id].school)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>School: {this.state.profile_data[this.state.id].school ? this.state.profile_data[this.state.id].school : "Nil"}</span>
                <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '10px',marginLeft: '10px', marginTop: '3px',color: (this.state.profile_data[this.state.id].level.length>0)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Gamelevel: {(this.state.profile_data[this.state.id].level.length > 0)  ? this.state.profile_data[this.state.id].level[0].game +":"+this.state.profile_data[this.state.id].level[0].game_level : "Nil"}</span>
              </div>
              :
              <div></div>

             }
              </div>
              <div className="col-md-4">
                {
                this.state.profile_data[this.state.id].customer_type == 'Child' ?

                  <div className="col-md-3" style={{flexDirection: 'column', display: 'flex', marginTop: '3px', marginLeft: '50px'}}>
                  <span style={{fontSize: '90%', fontWeight: 600,  marginLeft: '10px', color: (this.state.profile_data[this.state.id].father_name)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>Father's Name: {this.state.profile_data[this.state.id].father_name ? this.state.profile_data[this.state.id].father_name : "Nil"}</span>
                  <span style={{fontSize: '90%', fontWeight: 600, marginLeft: '10px', marginTop: '10px', color: (this.state.profile_data[this.state.id].father_number)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>Father's  No: {this.state.profile_data[this.state.id].father_number ? this.state.profile_data[this.state.id].father_number : "Nil"}</span>
                  <span style={{fontSize: '90%', fontWeight: 600,  marginLeft: '10px', marginTop: '10px', color: (this.state.profile_data[this.state.id].mother_name)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>Mothers Name: {this.state.profile_data[this.state.id].mother_name ? this.state.profile_data[this.state.id].mother_name : "Nil"}</span>
                  <span style={{fontSize: '90%', fontWeight: 600, marginLeft: '10px', marginTop: '10px', color: (this.state.profile_data[this.state.id].mother_number)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>Mothers No: {this.state.profile_data[this.state.id].mother_number ? this.state.profile_data[this.state.id].mother_number : "Nil"}</span>
                  <span style={{fontSize: '90%', fontWeight: 600, marginLeft: '10px', marginTop: '10px', color: (this.state.profile_data[this.state.id].apartment)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>Apartment: {this.state.profile_data[this.state.id].apartment ? this.state.profile_data[this.state.id].apartment : "Nil"}</span>
                  <span style={{fontSize: '90%', fontWeight: 600, marginLeft: '10px', marginTop: '10px', color: (this.state.profile_data[this.state.id].address)? '#000':'#FF0000', whiteSpace: 'nowrap', }}>Address: {this.state.profile_data[this.state.id].address ? this.state.profile_data[this.state.id].address.substring(0,70) : "Nil"}</span>
                 
                  </div>
              
                :
                <div>
                </div>
              }
              </div>

              <div style={{flexDirection: 'column',  marginBottom: '5px',  marginLeft: '3px', display: 'flex', alignItems: 'center', marginTop: '3px'}} className="col-md-3">
                         
                          <div className="col-md-1">
                            <Link
                              to={`../../crud/editLead/${this.state.id}`}
                              className="btn btn-info btn-md pull-left"
                              style={{
                                  backgroundColor: '#FDD60B',
                                  color: '#000',
                                  marginBottom: '2px'
                              }}>
                              <span style={{color: '#000'}}></span>
                              Edit Lead
                          </Link>
                          </div>
                          <div className="col-md-1">
                           <Link
                              to={`../../crud/scheduleDemo/${this.state.id}`}
                              className="btn btn-info btn-md pull-left"
                              style={{
                                  backgroundColor: '#FDD60B',
                                  color: '#000',
                                  marginBottom: '2px'
                              }}>
                              <span style={{color: '#000'}}></span>
                              Schedule Demo
                          </Link>
                          </div>
                          <div className="col-md-2">
                           <button className="btn btn-default" style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '1px', marginBottom: '2px', marginLeft: '14px'}}
                            type="button" onClick={()=>this.venueSms(this.props)}><span style={{color: '#000',}}>Venue SMS</span></button>
                          </div>
                          <div className="col-md-2">
                           <button className="btn btn-default" style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '1px', marginBottom: '2px', marginLeft: '14px'}}
                            type="button" onClick={()=>this.missedCallsms(this.props)}><span style={{color: '#000',}}>Missed Call SMS</span></button>
                          </div>
                          <div className="col-md-2">
                             <a
                                href={`https://api.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0ABenefits+of+playing+with+Sporthood%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`}
                                target="_blank"
                                className="btn btn-info btn-md pull-left"
                                style={{
                                    backgroundColor: '#25D366',
                                    color: '#000',
                                    marginBottom: '2px'
                                }}>
                                <span style={{color: '#000'}}></span>
                                Send in Whatsapp.
                            </a>
                          </div>                          
                       </div>
            </div>
          
          <div className="col-md-12" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', border: '1px solid #eee'}}>
           <div>
            {this.renderTabButtons(this.state.active_tab)}
          </div> 
          <div style={{flexDirection: 'row', justifyContent: 'space-between', marginLeft: '11px'}}>
          {
            (this.state.active_tab==1) ?
              <div className="col-md-12" style={{flexDirection: 'column',    display: 'flex', backgroundColor: '#fff', marginLeft: '3px', padding: '1%',  }}>
              <h4 style={{textAlign:'center'}}>Last 5 Leads</h4>
                <div>
                  {
                    this.state.profile_data[this.state.id].leads.map((lead, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'column', marginBottom: '1%', padding: '1%', height: '80px'}}>
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                        <span style={{color: '#000', fontSize: '14px'}}>Followup: </span>
                        <span style={{color: '#000', fontSize: '15px', fontWeight: '600', }}>{lead.follow_up_date}</span>
                        </div>
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                        <span style={{color: '#000', fontSize: '15px', fontWeight: '600',}}>{lead.buddy[0]}</span>
                        </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000',  fontSize: '15px', fontWeight: '600'}}>{lead.venue}</span>
                         </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontSize: '14px', fontWeight: '600'}}>{lead.status}</span>
                        </div>
                        <div className="col-md-4" style={{justifyContent: 'center', flexWrap: 'wrap', marginTop: '2px'}}>
                        <span style={{color: '#000', fontSize: '14px'}}>Comment: </span>
                        <span style={{color: '#000', alignSelf: 'center', fontSize: '16px', fontWeight: '600'}}>{lead.comment}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>

            </div>
            :
            (this.state.active_tab == 2) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '3px', padding: '1%', display: 'flex'}}>
              <h4 style={{textAlign:'center'}}>Last 5 Bookings</h4>
                <div>
                  {
                    this.state.profile_data[this.state.id].bookings.map((booking, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'column', marginBottom: '1%', height: '80px', padding: '1%'}}>
                        <div className="col-md-4" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                        <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{booking.fixture}</span>
                        </div>
                        <div className="col-md-4" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                        <span style={{color: '#000',  fontSize: '14px', fontWeight: '600', }}>{booking.package}</span>
                        </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                            <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{booking.date}</span>
                         </div>
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                           <span style={{color: '#000', fontSize: '14px'}}>Status </span>
                            <span style={{color: '#000',  fontSize: '15px', fontWeight: '600'}}>{booking.status}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>
            </div>
            :
               <div style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '5px', padding: '1%', display: 'flex'}}>
              <h4 style={{textAlign:'center'}}>Last 180 days Subscriptions</h4>
                <div>
                  {
                    this.state.profile_data[this.state.id].subscriptions.map((data, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', padding: '1%', flexDirection: 'column', marginBottom: '3px'}} className="col-md-12">
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                        <div className="col-md-3">
                        <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{data.package}</span>
                        </div>
                        <div className="col-md-3">
                        <span style={{color: '#000', justifyContent: 'space-between', fontSize: '14px', fontWeight: '600'}}>Sessions Left: {data.sessions_left}</span>
                        </div>
                        <div className="col-md-3">
                        <span style={{color: '#000',fontSize: '14px', fontWeight: '600' }}>Start date: {data.start_date}</span>
                        </div>
                        
                        <div style={{display: 'contents'}} className="col-md-3">
                           <button className="btn btn-default" style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '2px', marginRight: '38px'}}
                            type="button" ><a href={"https://api.sporthood.in/api/v1/invoice/download/?subscription_id="+data.id}>Download</a></button>
                          </div>
                        </div>
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                            <div className="col-md-3">
                            <span style={{color: '#000', alignSelf: 'center', fontSize: '15px', fontSize: '13px', fontWeight: '600'}}>{data.gamename} : {data.gamentypename}</span>
                            </div>
                            <div className="col-md-3">   
                            <span style={{color: '#000', justifyContent: 'space-between', fontSize: '14px', fontWeight: '600'}}>Total Pause: {data.total_pause}</span>
                            </div>
                            
                            <div className="col-md-3">
                            <span style={{color: '#000', fontSize: '14px', fontWeight: '600'}}>End Date: {data.end_date}</span>
                            </div>
                            <div style={{display: 'contents'}} className="col-md-3">
                           <button className="btn btn-default" style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '2px',marginTop: '3px',}}
                            type="button" ><a href={"https://api.sporthood.in/v2/cart/edit_homebatches/?subscription_id="+data.id}>Edit Homebatch</a></button>
                          </div>
                        </div>
                      
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                          <div className="col-md-3">   
                          <span style={{color: '#000', justifyContent: 'space-between', fontSize: '14px', fontWeight: '600'}}>Amount: {data.amount}</span>
                          </div>
                          <div className="col-md-3">   
                            <span style={{color: '#000', justifyContent: 'space-between', fontSize: '14px', fontWeight: '600'}}>Used Pause: {data.subscription_pause.length}</span>
                            </div>
                            <div className="col-md-3">   
                            <span style={{color: '#000', justifyContent: 'space-between', fontSize: '14px', fontWeight: '600'}}>Status: {data.status}</span>
                            </div>
                            <div style={{display: 'contents'}} className="col-md-3">
                          {data.total_pause > 0 ?
                          <div>
                        {data.status === "active" ?
                           <button className="btn btn-default" style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '2px',marginTop: '3px',}}
                            type="button" onClick={()=>this.setState({dialog_open:true, subscription_id:data.id})}>Pause Subscription</button>
                            :
                            <button className="btn btn-default" style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '2px',marginTop: '3px',}}
                            type="button">Paused</button>
                        }

                          <div>
                            {this.state.subscription_id === data.id &&
                          <Dialog
                                actions={actions}
                                modal={false}
                                open={this.state.dialog_open}
                                onRequestClose={this.handleClose}
                              >
                                <div>
                                  <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      Date till you want to Pause(DD/MM/YYYY)
                                    </div>
                                    <input type="text" style={styles.input} name="pause_date" className="required"
                                      value={this.state.pause_date} onChange={this.handleChange}/>
                                  </div>
                                </div>
                              </Dialog>
                            }
                            </div>
                            </div>
                            :
                            <button className="btn btn-default" style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '2px',marginTop: '3px',}}
                            type="button" onClick={()=>alert("Can't Pause Subscription")}>Pause Subscription</button>

                          } 
                          </div>
                        </div>
                      </div>
                      ))
                  }
                </div>
            </div>
          }
          </div>
          </div>

          </div>
          :
         <div className="loading-overlay"><Spinner name="ball-grid-pulse" color="darkturquoise"/></div>
      }
      </div>
    );
  }
}

export default CustomerDetails;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/customerDetails/index.js